import React, {useEffect} from 'react';
import useAuthStore from "../../store/auth";
import {useNavigate} from "react-router-dom";
import {useQueryClient} from "react-query";

import {apollo} from "../../utils/apollo";
import {LOGOUT} from "../../utils/graphql";

function Logout() {
	const {clearToken} = useAuthStore();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	
	useEffect(() => {
		queryClient.clear();
		
		const performLogout = async () => {
			try {
				// Always call the backend logout mutation — authentication is handled
				// via the httpOnly cookie even if the in-memory token is absent.
				// This ensures all Sanctum tokens are revoked server-side immediately.
				await apollo.mutate({ mutation: LOGOUT });
			} catch (e) {
				console.error("Failed to revoke token on backend:", e);
			} finally {
				// Clear Zustand in-memory state
				clearToken();
				// Explicitly wipe localStorage to remove any stale persisted auth data
				localStorage.removeItem('x-auth');
				navigate("/login");
			}
		};
		
		performLogout();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50/50">
			<div className="text-center font-bold text-gray-500">Signing out...</div>
		</div>
	);
}

export default Logout;